import React from 'react'
/* eslint-disable react/forbid-prop-types */
import { any } from 'prop-types'
import PermissionRouteWithFallback from './PermissionRouteWithFallback'

export default function AdminPermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  return (
    <PermissionRouteWithFallback
      component={Component}
      path={path}
      exact={exact}
      fallback={Fallback}
      requirePersonalData={requirePersonalData}
      permissionName="DiscoveryAdminUIPermission"
      permissionContext="DiscoveryAdminUIContext"
    >
      {children}
    </PermissionRouteWithFallback>
  )
}

AdminPermissionRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
  path: any,
  exact: any,
  requirePersonalData: any,
}
